import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseUrlInterceptor } from './app/api/interceptors/base-url.interceptor';
import { AuthInterceptor } from './app/api/interceptors/auth.interceptor';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app/app-routing.module';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    // BaseUrlInterceptor resolves service prefixes (inventory:, order:, ...) to the gateway URL.
    // Must run BEFORE AuthInterceptor so the resolved URL is available for host matching.
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    // AuthInterceptor attaches withCredentials: true (sends session cookie) and handles 401/403.
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
}).catch(err => {
  if (!environment.production) {
    console.error(err);
  }
});
